import clsx from 'clsx';
import styles from './Container.module.scss';
import { useMemo, type ReactNode } from 'react';
import {
  ContainerContext,
  type ContainerContextValue,
} from './ContainerContext';

interface Props {
  children: ReactNode;
  color?: 'default' | 'error';
  title?: string;
  addon?: ReactNode;
}

export function Container({ children, color = 'default', ...props }: Props) {
  const value = useMemo<ContainerContextValue>(() => ({}), []);

  return (
    <ContainerContext.Provider value={value}>
      <div className={clsx(styles['container'], styles['color-' + color])}>
        {(props.title || props.addon) && (
          <div className={styles['top']}>
            <div className={styles['title']}>{props.title}</div>
            {props.addon && (
              <div className={styles['addon']}>{props.addon}</div>
            )}
          </div>
        )}
        <div className={styles['content']}>{children}</div>
      </div>
    </ContainerContext.Provider>
  );
}
